module.exports = __webpack_public_path__ + "static/media/tabChangeSFX.93c93874.mp3";